import React from 'react';

import { Icon } from 'ui';

import { TooltipCustom } from '../../../../../components/atoms/legacyAtoms';

import './_tutor-usage-stat-card.scss';

type IconVariant = 'purple' | 'blue' | 'orange' | 'green';

type TutorUsageStatCardProps = {
  hasInfo?: boolean;
  iconType: string;
  iconVariant: IconVariant;
  infoTooltip?: string;
  label: string;
  subtitle: string;
  trend: number | null;
  trendText: string;
  value: string;
};

function TutorUsageStatCard({
  hasInfo = false,
  iconType,
  iconVariant,
  infoTooltip,
  label,
  subtitle,
  trend,
  trendText,
  value,
}: Readonly<TutorUsageStatCardProps>): JSX.Element {
  const hasTrend = trend !== null;
  const isPositive = hasTrend && trend >= 0;
  let trendModifier: 'positive' | 'negative' | 'neutral' = 'neutral';
  if (hasTrend) {
    trendModifier = isPositive ? 'positive' : 'negative';
  }
  const trendIconType = isPositive ? 'trend-up' : 'trend-down';
  const trendIconColor = isPositive ? 'success' : 'red';
  const trendPrefix = isPositive ? '+' : '';

  return (
    <div className="tutor-usage-stat-card">
      <div className="tutor-usage-stat-card__header">
        <div className={`tutor-usage-stat-card__icon tutor-usage-stat-card__icon--${iconVariant}`}>
          <Icon color="default" size="md" name={iconType} />
        </div>
        {hasInfo && (
          <div className="tutor-usage-stat-card__info-icon">
            {infoTooltip ? (
              <TooltipCustom placement="bottom-end" title={infoTooltip}>
                <span>
                  <Icon color="grey-03" size="md" name="info-circle" />
                </span>
              </TooltipCustom>
            ) : (
              <Icon color="grey-03" size="md" name="info-circle" />
            )}
          </div>
        )}
      </div>
      <p className="tutor-usage-stat-card__label">{label}</p>
      <p className="tutor-usage-stat-card__value">{value}</p>
      <p className="tutor-usage-stat-card__subtitle">{subtitle}</p>
      <p className={`tutor-usage-stat-card__trend tutor-usage-stat-card__trend--${trendModifier}`}>
        {hasTrend && <Icon color={trendIconColor} size="xs" name={trendIconType} />}
        {hasTrend ? (
          <>
            {trendPrefix}
            {trend}%<span className="tutor-usage-stat-card__trend-text">{trendText}</span>
          </>
        ) : (
          <span className="tutor-usage-stat-card__trend-text tutor-usage-stat-card__trend-text--na">N/A</span>
        )}
      </p>
    </div>
  );
}

export default TutorUsageStatCard;
